export const SELECT_HABILITADO_DESHABILITADO = [
    {
        value: 0,
        label: 'DESHABILITADO',
    },
    {
        value: 1,
        label: 'HABILITADO',
    },
];